import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { Switch } from 'react-router-dom'

import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import MessagesEdit from './Edit'
import MessagesNew from './New'
import List from './List'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_MESSAGES } from 'app-support/permissions/Permissions'
import { messagesRoute, messagesRouteEdit, messagesRouteNew } from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler(messagesRoute))

export const MessagesContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_MESSAGES} exact path={messagesRouteNew} component={MessagesNew} />
    <PermissionRoute permission={PERMISSION_MANAGE_MESSAGES} exact path={messagesRouteEdit} component={MessagesEdit} />
    <PermissionRoute permission={PERMISSION_MANAGE_MESSAGES} exact path={messagesRoute} component={List} />
  </Switch>
)

export default enhance(MessagesContainer)
